import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import { getFileAttachementByEntityId } from "../../../api/fileAttachement";
import { toast } from "sonner";
import { Spin } from "antd";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: {
    externalID?: string;
    academicYear?: string;
  };
  onClose: () => void;
};
const ExternalModalApercu = ({ show, metaData, onClose }: Props) => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      if (!metaData?.externalID) return;

      const response = await getFileAttachementByEntityId(
        metaData?.externalID,
        "ExternalNote",
        buildPermissionContext(Resource.REGISTRATION, Action.READ),
      );
      // console.log("Apercu External : ", response);
      setPdfBlobUrl(response.data[0]?.temporaryUrl);
    } catch (error: any) {
      // console.log("erreur apercus note externe: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!show) return;
    handleDownload();
  }, [show]);

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Aperçu de la Pièce</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          {!pdfBlobUrl && isLoading ? (
            <Spin
              indicator={
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              }
            />
          ) : (
            <iframe
              src={`${pdfBlobUrl}`}
              style={{ width: "100%", height: "100%" }}
              title="Aperçu PDF"
              // sandbox="allow-same-origin"
              onError={(error: any) => {
                // console.error("Erreur de chargement du PDF", error);
                // Affichez un message d'erreur si nécessaire
                toast.error(
                  error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    "Une erreur s'est produite, veuillez ressayer plus tard..",
                );
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button
            className="btn btn-primary"
            onClick={handleDownload}
            // disabled={!metaData?.urlPiece}
          >
            Télécharger
          </button>
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  ExternalModalApercu,
  [buildPermission(Resource.EXTERNAL_NOTE, Action.READ)],
  "masquer",
);
